import { render } from "./News.vue?vue&type=template&id=2a9490c9&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=2a9490c9&scoped=true&lang=css"
import "./News.vue?vue&type=style&index=1&id=2a9490c9&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9490c9"]])

export default __exports__